module.exports = __webpack_public_path__ + "media/images/landing/animations/animace-dektop-2ace85c8a67130f6e4dd08ebdfb24e48.mp4";